<!-- //
版本组件
@auth xuyd
@date 2024-05-05
//-->
<template>
  <div class="card">
    <span class="info" v-if="value">V{{ value }}</span>
    <span v-else>未定版</span>
  </div>
</template>

<script>


export default {
  name: 'CompVersion',
  data() {
    return {}
  },
  props: {
    value: [String, Number],
    rowData: {
      type: Object,
      default: () => {
        return {}
      },
    },
  }
}
</script>

<style lang="less" scoped>
.card {
  background-color: #444444;
  color: #fedb8b;
  font-size: 12px;
  width: 50px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
}
</style>
